
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Civilite from '@/extend/classes/Civilite';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeCivilite' })

export default class storeCivilite extends VuexModule {
  // States
  private reccords: Civilite[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get civiliteLoading (): boolean {
    return this.dataLoading;
  }
  private get civiliteRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get civiliteLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewCivilite() {
    return (): Civilite => { 
      return this.getCivilite(0, true);
    }
  }

  
  public get getCivilite () {
    return (id: number, canCreate = false): Civilite => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Civilite can't be 0")
        return new Civilite();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Civilite();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Civilite.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromCivilite(data.reccords[0] as Civilite);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listCivilite (): Civilite[] {
    return this.reccords;
  }

  public get listConfigCivilite (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mCiviliteRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mCiviliteClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mCiviliteLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mCiviliteLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Civilite.fromJson(reccord as Civilite));
    })
    Civilite.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mCiviliteConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mCiviliteCreated (obj: Civilite): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareCivilite(obj)) {
          api.fromCivilite(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareCivilite(obj)) {
            api.fromCivilite(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mCiviliteUpdated (obj: Civilite): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareCivilite(obj)) {
          api.fromCivilite(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mCiviliteDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerCivilite (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.civiliteRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerCivilite(this.civiliteCreated, this.civiliteUpdated, this.civiliteDeleted);
          this.mCiviliteRegistered();
        } else {
          setTimeout(() => resolve(this.registerCivilite(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.civiliteLoading && !this.civiliteLoaded) {
          this.mCiviliteLoading(true);
          return Civilite.list(filter)
            .then((data: ListData) => {
              this.mCiviliteLoaded(data);
              this.mCiviliteLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredCivilite (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.civiliteLoading) {
        this.mCiviliteLoading(true);
        return Civilite.list(filter)
          .then((data: ListData) => {
            this.mCiviliteLoaded(data);
            this.mCiviliteLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createCivilite (obj: Civilite): Promise<Civilite> {
    return new Promise((resolve, reject) => {
      return Civilite.fromJson(obj).createForStoreCivilite()
        .then((reccords) => {
          this.mCiviliteCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateCivilite (obj: Civilite): Promise<Civilite> {
    return new Promise((resolve, reject) => {
      return Civilite.fromJson(obj).updateForStoreCivilite()
        .then((reccords) => {
          this.mCiviliteUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteCivilite (obj: Civilite): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Civilite.fromJson(obj).deleteForStoreCivilite()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mCiviliteDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private civiliteCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mCiviliteConfigUpdated(config)
    const obj = objConfig.obj as Civilite;
    this.mCiviliteCreated(Civilite.fromJson(obj));
  }

  @Action
  private civiliteUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mCiviliteConfigUpdated(config)
    const obj = objConfig.obj as Civilite;
    this.mCiviliteUpdated(Civilite.fromJson(obj));
  }

  @Action
  private civiliteDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Civilite;
    this.mCiviliteDeleted(obj.id);
  }
}
